import React from "react";
import { useLang } from "../lib/i18n";

const STYLES = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  overdue: "bg-red-50 text-red-700 border-red-200",
  redeemed: "bg-blue-50 text-blue-700 border-blue-200",
  forfeited: "bg-gray-100 text-gray-700 border-gray-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  suspended: "bg-red-50 text-red-700 border-red-200",
  pledged: "bg-amber-50 text-amber-700 border-amber-200",
  inventory: "bg-slate-100 text-slate-700 border-slate-200",
  auction: "bg-purple-50 text-purple-700 border-purple-200",
  sold: "bg-teal-50 text-teal-700 border-teal-200",
  closed: "bg-slate-100 text-slate-600 border-slate-200",
};

export function StatusBadge({ status }) {
  const { t } = useLang();
  const style = STYLES[status] || STYLES.pending;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${style}`}
    >
      {t(`status.${status}`)}
    </span>
  );
}
